module.exports = __webpack_public_path__ + "img/DFK_DDC-02.332df4b8.png";